import { shallowMount } from "@vue/test-utils";
import Company from "@/components/core/composite/combos/Company";

describe("Company component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Company, {
      propsData: {
        value: "",
        name: "",
        label: ""
      }
    });
  });

  it("Renders del component Company", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
